module.exports = __webpack_public_path__ + "static/media/a5.bc2d2c4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sangwenfeng/a5.mp3
// module id = c4WX
// module chunks = 0